import React from 'react'
import { Container, Paper, List, ListItemText, Link } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Colors } from '../styles/theme'
import { useMediaQuery, useTheme } from '@mui/material'

const NavList = styled(List)({
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: { xs: 3, sm: 5, md: 7 },
    padding: { xs: '14px 16px', sm: '18px 32px' },
})

const NavLink = styled(Link)(({ theme }) => ({
    color: Colors.primary,
    fontWeight: 500,
    fontSize: '1rem',
    textDecoration: 'none',
    padding: '8px 16px',
    borderRadius: '8px',
    transition: 'all 0.25s ease',
    display: 'block', // ← makes the secret sauce
    textAlign: 'center', // ← ensures text is centered inside the block

    [theme.breakpoints.down('sm')]: {
        fontSize: '0.85rem',
    },

    '&:hover, &:focus, &:active': {
        color: '#fcf6f0',
        fontSize: '0.85rem',
    },
}))

export default function NavBar() {
    const theme = useTheme()
    const isXs = useMediaQuery(theme.breakpoints.down('sm'))
    const inst = isXs ? 'Instal.' : 'Installation'

    return (
        <Container sx={{ mb: { xs: 1, md: 4 }, mx: 0, px: 0 }}>
            <Paper
                elevation={4}
                sx={{
                    borderRadius: 2,
                    overflow: 'hidden',
                }}
            >
                <NavList sx={{ mx: { xs: 0, md: 4 } }}>
                    <ListItemText sx={{ textAlign: 'center' }}>
                        <NavLink href="/">Home</NavLink>
                    </ListItemText>
                    <ListItemText sx={{ textAlign: 'center' }}>
                        <NavLink href="/shop">Store</NavLink>
                    </ListItemText>
                    <ListItemText sx={{ textAlign: 'center' }}>
                        <NavLink href="/videos">{inst} Videos</NavLink>
                    </ListItemText>
                    <ListItemText sx={{ textAlign: 'center' }}>
                        <NavLink href="/manual">{inst} Manual</NavLink>
                    </ListItemText>
                </NavList>
            </Paper>
        </Container>
    )
}
